import request from 'utils/request'

const studyScheduleVisitsBase = studyId => `/control/studies/${studyId}/study_schedules_visits`

export const participantScheduleVisitUrls = {
  /** POST — create participant / adhoc visit. */
  create: (studyId, ptpId) => `${studyScheduleVisitsBase(studyId)}/participants/${ptpId}`,
  /** PATCH — update participant schedule visit (control server v3). */
  update: (studyId, ssvpId, ptpId) =>
    `/control/v3/studies/${studyId}/study_schedules_visits/${ssvpId}/participants/${ptpId}`,
}

export const patchParticipantScheduleVisit =
  (studyId, ssvpId, ptpId, body, onSuccess = () => {}) =>
  dispatch =>
    dispatch(
      request({
        method: 'PATCH',
        url: participantScheduleVisitUrls.update(studyId, ssvpId, ptpId),
        success: onSuccess,
        hasLoader: true,
        loadingKey: 'visitSchedules',
        body: JSON.stringify(body),
      }),
    )
